import React from 'react';
import { Route } from 'react-router';
import Inventory, {
  Summary,
  Transfer,
  Adjustment,
  PurchaseOrder,
  Supplier,
} from 'pages/Inventory';
import createCustomRoute from 'hocs/createCustomRoute';

const InventoryRoutes = createCustomRoute('InventoryRoutes', props => (
  <Route {...props} component={Inventory}>
    <Route path="summary" component={Summary} />
    <Route path="suppliers" component={Supplier} />
    <Route path="purchase_orders" component={PurchaseOrder} />
    <Route path="transfer" component={Transfer} />
    <Route path="adjustment" component={Adjustment} />
  </Route>
));

export default InventoryRoutes;
